import { FormControl, FormLabel, Switch as CSwitch } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';

import { routePaths } from 'global/routePaths';

const Switch: React.FC<unknown> = () => {
  const { t } = useTranslation(['jobsTasks', 'common']);

  const navigate = useNavigate();
  const location = useLocation();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      navigate(routePaths.jobsAndTasks.tasks);
    } else {
      navigate(routePaths.jobsAndTasks.jobs);
    }
  };

  return (
    <div>
      <FormControl display="flex" alignItems="center">
        <FormLabel htmlFor="jobs-tasks-switch" mb="0" mr="2" fontSize="sm">
          {t('common:jobs')}
        </FormLabel>
        <CSwitch
          id="jobs-tasks-switch"
          onChange={handleChange}
          colorScheme="primary"
          isChecked={location.pathname === routePaths.jobsAndTasks.tasks}
        />
        <FormLabel htmlFor="jobs-tasks-switch" mb="0" ml="2" fontSize="sm">
          {t('common:tasks')}
        </FormLabel>
      </FormControl>
    </div>
  );
};

export default Switch;
